import React, {useState} from "react";
import {Row} from "antd";
import {useFetch} from "../../../hooks/useFetch";
import stores from "../../../store/stores";
import Filters from "./filters/Filters";

import ResponsiveDataTable from "./responsiveDataTable/ResponsiveDataTable";
import ActionButtons from "./actionButtons/ActionButtons";
import UploadPoolShiftButton from "./uploadPoolShiftButton/UploadPoolShiftButton";
import CopyForecastButton from "./copyForecastButton/CopyForecastButton";

const Pools = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [filters, setFilters] = useState({
        city: "all",
        integrationType: "all"
    });

    const [loading, pools] = useFetch({
        fetchFn: stores.poolStore.getPoolList.bind(null, {
            limit: 10,
            page: currentPage,
            city: filters.city,
            integrationType: filters.integrationType
        }),
        dependencies: [filters, currentPage]
    });
    const [poolOptionsLoading, poolOptions] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.poolStore.getPoolList.bind(null, {
            limit: 1000,
            page: 1,
            city: "all",
            integrationType: "all"
        }),
        dependencies: [],
        initialCall: true
    });
    return (
        <div>
            <Row gutter={[8, 8]}>
                <Filters
                    setCurrentPage={setCurrentPage}
                    setFilters={setFilters}
                    filters={filters}
                />
            </Row>
            <Row justify="end">
                <CopyForecastButton
                    poolOptions={poolOptions}
                    poolOptionsLoading={poolOptionsLoading}
                />
                <UploadPoolShiftButton />
                <ActionButtons />
            </Row>
            <Row>
                <ResponsiveDataTable
                    loading={loading}
                    data={pools?.data || []}
                    dataCount={pools?.pagination?.totalItems || 0}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                />
            </Row>
        </div>
    );
};

export default Pools;
